import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function TextInput(props) {
  const { t } = useTranslation();
  const {
    name,
    label,
    value,
    placeholder,
    onChange,
    width,
    variant,
    ...other
  } = props;

  const placeHolder = placeholder ?? name;
  const labelD = label ?? name;

  return (
    <TextField
      variant={variant || 'outlined'}
      label={
        <span style={{ fontWeight: 'bold' }}>{t(`FORM.FIELD.${labelD}`)}</span>
      }
      name={name}
      placeholder={t(`FORM.FIELD_PLACE_HOLDER.${placeHolder}`)}
      sx={{
        width: width || '100%',
      }}
      value={value}
      onChange={onChange}
      fullWidth
      {...other}
    />
  );
}
